import { AgentPresenceEventStatus } from '@repo/sdk/models/components';

import { UseWebsocketQueryOptions } from '@/hooks/query-hooks/websockets';
import { QueryToast } from '@/queries/types';

export type AgentPresence = {
  agentId: string;
  status: AgentPresenceEventStatus;
  statusAt: Date;
  updatedAt: Date;
};

export interface UserActivityQueryProps {
  userId: string | undefined;
}

export const userActivityQuery = ({
  userId,
}: UserActivityQueryProps): UseWebsocketQueryOptions<AgentPresence[] | null> => {
  return {
    enabled: !!userId,
    queryKey: [userId, 'userActivity'],
    staleTime: Infinity,
    meta: {
      toast: {
        severity: 'off',
      } as QueryToast,
    },
    webSocketUrl: `/bff/v1/activity-stream`,
  };
};
